import React from "react";
import VehicleOBDList from "../vehicleOBDMonitoring/VehicleOBDList";

const VehicleFuelUsage = () => {
    return(
        <VehicleOBDList fuel={true}/>
    )
}

export default VehicleFuelUsage;